import { SolutionPage } from './SolutionPage'
import { solutionsData } from '@/data/solutions'

export default function Sales() {
  return <SolutionPage solution={solutionsData.sales!} />
}
